import React, { useEffect, useState } from "react";
import "./FloorDetailsStyles.scss";
import close from "../../../../assets/close.png";
import back from "../../../../assets/arrow.png";

import email from "../../../../assets/email.svg";
import more from "../../../../assets/more.png";
import edit from "../../../../assets/pencil.png";
import tag from "../../../../assets/tag.png";
// import man from "../../../../assets/man.png";
// import notes from "../../../../assets/notes.png";
// import note from "../../../../assets/notepad.png";
// import comment from "../../../../assets/comment.png";
import calendar from "../../../../assets/clIC.svg";
// import time from "../../../../assets/alarm.svg";
import covers from "../../../../assets/friends.png";
import duration from "../../../../assets/duration.png";
import table from "../../../../assets/cover.svg";
import status from "../../../../assets/status.png";
import est from "../../../../assets/alarm.svg";
import reserve from "../../../../assets/restaurant.svg";
import Button from "../../../../components/button/Button";
import moment from "moment";
import NumberInput from "../../../../components/ReservationComponents/numberInput/NumberInput";
import { useDispatch, useSelector } from "react-redux";
import {
  setAllocatedTables,
  setBookingStatus,
  setBookingTags,
  setFloorData,
} from "../../../../../application/reducer/bookingSlice";
import DurationInput from "../../../../components/ReservationComponents/numberInput/DurationInput";
import TimeInput from "../../../../components/ReservationComponents/numberInput/TimeInput";
import DateModal from "../../../../components/ReservationComponents/modal/dateModal/DateModal";
import StatusModal from "../../../../components/ReservationComponents/modal/statusModal/StatusModal";
import DurationModal from "../../../../components/ReservationComponents/modal/durationModal/DurationModal";
import TimeModal from "../../../../components/ReservationComponents/modal/timeModal/TimeModal";
import CoverModal from "../../../../components/ReservationComponents/modal/coverModal/CoverModal";
import {
  getBookingByID,
  getFloorDetails,
  getStatus,
  getTags,
  updateReservation,
} from "../../../../../infra/apis/bookings/requests/Booking";
// import NotesModal from "../../../../components/ReservationComponents/modal/noteModal/NotesModal";
// import TagModal from "../../../../components/ReservationComponents/modal/tagModal/TagModal";
import TextArea from "../../../../components/textarea/TextArea";
import { RootState } from "../../../../../application/store";
import Alert from "../tableDetails/Alert";
import _ from "lodash";
import EstModal from "../../../../components/ReservationComponents/modal/estModal/EstModal";
import WarningModal from "../../../../components/ReservationComponents/errorModal/WarningModal";
interface FloorDetailsProps {
  isModalOpen: boolean;
  onClose: () => void;
  tableData: any;
  setSelectedTables: React.Dispatch<React.SetStateAction<boolean>>;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  date: any;
  setDate: React.Dispatch<React.SetStateAction<any>>;
  bookingTime: string;
  setBookingTime: React.Dispatch<React.SetStateAction<string>>;
  guest: number;
  setGuest: React.Dispatch<React.SetStateAction<number>>;
  setSelectedTable: React.Dispatch<React.SetStateAction<any>>;
  setIsUpdateSuccess: React.Dispatch<React.SetStateAction<boolean>>;
}

const FloorDetails: React.FC<FloorDetailsProps> = ({
  isModalOpen,
  onClose,
  tableData,
  setSelectedTables,
  setIsModalOpen,
  date,
  setDate,
  bookingTime,
  setBookingTime,
  guest,
  setGuest,
  setSelectedTable,
  setIsUpdateSuccess,
}) => {
  const [time, setTime] = useState<string>("0 min");
  const [interval, setInterval] = useState<number>(120);
  const [statusValue, setStatusValue] = useState<any>(
    tableData ? tableData.StatusInfo : ""
  );
  const [request, setRequest] = useState<string>(
    tableData ? tableData.ReservationNotes : ""
  );
  const [tags, setTagsData] = useState<any[]>(
    tableData ? (tableData.Tags !== null ? tableData.Tags : []) : []
  );
  const [isRequestOpen, setRequestOpen] = useState<boolean>(false);
  const [isStatusOpen, setStatusOpen] = useState<boolean>(false);
  const [isCoversOpen, setCoversOpen] = useState<boolean>(false);
  const [isDurationOpen, setDurationOpen] = useState<boolean>(false);
  const [isDatOpen, setDateOpen] = useState<boolean>(false);
  const [isTimeOpen, setTimeOpen] = useState<boolean>(false);
  const [isTagOpen, setTagOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSaveLoading, setIsSaveLoading] = useState(false);
  const [isTableError, setIsTableError] = useState<boolean>(false);
  const [isSaveOpen, setIsSaveOpen] = useState(false);
  const [isAlertVisible, setIsAlertVisible] = useState("");
  const [selectedRes, setSelectedRes] = useState<any>(null);
  const [isWaitOpen, setWaitOpen] = useState<boolean>(false);
  const [waitCheck, setWaitCheck] = useState<boolean>(false);
  const [waitESt, setWaitsEst] = useState<string>("15 mins");
  const [isUpdateOpen, setIsUpdateOpen] = useState(false);

  const floorData = useSelector((state: RootState) => state.booking.floorData);
  const convertTimeToMinutes = (timeString: string) => {
    let totalMinutes = 0;

    // Use a regular expression to extract the numbers and their units
    const timeParts = timeString.match(/(\d+)\s*(h|min)/g);

    if (timeParts) {
      timeParts.forEach((part) => {
        if (part.includes("h")) {
          const hours = parseInt(part.replace("h", ""), 10);
          totalMinutes += hours * 60;
        } else if (part.includes("min")) {
          const minutes = parseInt(part.replace("min", ""), 10);
          totalMinutes += minutes;
        }
      });
    }

    return totalMinutes;
  };
  const convertMinutesToTime = (totalMinutes: any) => {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    let timeString = "";
    if (hours > 0) {
      timeString += `${hours} h `;
    }
    if (minutes > 0) {
      timeString += `${minutes} mins`;
    }

    return timeString.trim();
  };
  useEffect(() => {
    getStatus().then((response: any) => {
      dispatch(setBookingStatus(response));
    });
    getTags().then((response: any) => {
      dispatch(setBookingTags(response));
    });
  }, []);
  useEffect(() => {
    if (tableData) {
      getBookingByID(tableData?.BookingID).then((response) => {
        setSelectedRes(response);
      });
    }
  }, [tableData]);
  useEffect(() => {
    let dateFormat = moment(date).format("YYYY-MM-DD");
    getFloorDetails(dateFormat).then((response: any) => {
      const sortedFloor: any = [...response].sort(
        (a, b) => a.Priority - b.Priority
      );
      dispatch(setFloorData(sortedFloor));
    });
  }, [date]);
  useEffect(() => {
    setInterval(tableData?.BookingDetails?.Duration);
    setTime(convertMinutesToTime(tableData?.BookingDetails?.Duration));
    setGuest(tableData?.BookingDetails?.NumberOfPeople);
    setStatusValue(tableData?.StatusInfo);
    setBookingTime(tableData?.BookingDetails?.BookingTime);
    setWaitsEst(
      convertMinutesToTime(
        !tableData?.WaitList.Enabled ? 15 : tableData?.WaitList.WaitTime
      )
    );
    let dateValue = new Date(tableData?.BookingDetails?.BookingDate);
    setDate(
      new Date(
        dateValue.getUTCFullYear(),
        dateValue.getUTCMonth(),
        dateValue.getUTCDate(),
        dateValue.getUTCHours(),
        dateValue.getUTCMinutes(),
        dateValue.getUTCSeconds()
      )
    );
    setRequest(tableData.ReservationNotes ? tableData.ReservationNotes : "");
    setTagsData(tableData.Tags !== null ? tableData.Tags : []);
  }, []);
  useEffect(() => {
    let bookingDetails = {
      ...tableData.BookingDetails,
      BookingDate: moment(date).format("YYYY-MM-DDTHH:mm:ss[Z]"),
      BookingTime: bookingTime,
      Duration: convertTimeToMinutes(time),
      NumberOfPeople: guest,
    };
    let newTableDate = {
      ...tableData,
      Status: statusValue?.DisplayName,
      StatusInfo: statusValue,
      BookingDetails: bookingDetails,
    };
    setSelectedTable(newTableDate);
  }, [time, date, guest, bookingTime, statusValue]);
  const convertTimeToMinutesString = (timeString: any) => {
    const [hours, minutes] = timeString.split(":").map(Number);
    return hours * 60 + minutes;
  };
  const isTimeMatchingReservationWithDuration = (
    time: string,
    reservation: any
  ): boolean => {
    const givenTimeInMinutes = convertTimeToMinutesString(time);
    const bookingTimeInMinutes = convertTimeToMinutesString(
      reservation?.BookingDetails?.BookingTime
    );
    const endTimeInMinutes =
      bookingTimeInMinutes + reservation?.BookingDetails?.Duration;

    return (
      givenTimeInMinutes >= bookingTimeInMinutes &&
      givenTimeInMinutes < endTimeInMinutes
    );
  };
  const isTimeMatchingReservation = () => {
    let reservations = floorData
      .flatMap((item: any) =>
        item.Tables.flatMap((res: any) => res.Reservations)
      )
      .filter((res: any) => res.BookingID !== tableData.BookingID);
    if (reservations && reservations.length > 0) {
      return reservations.some((reservation: any) => {
        return reservation.AssetAllocation?.some((res: any) => {
          return tableData?.AssetAllocation.some((table: any) => {
            let dateValue = new Date(reservation?.BookingDetails?.BookingDate);

            let resDate = new Date(
              dateValue.getUTCFullYear(),
              dateValue.getUTCMonth(),
              dateValue.getUTCDate(),
              dateValue.getUTCHours(),
              dateValue.getUTCMinutes(),
              dateValue.getUTCSeconds()
            );
            return (
              res.RefNo === table.RefNo &&
              moment(resDate).format("DD-MM-yyyy") ===
                moment(date).format("DD-MM-yyyy") &&
              isTimeMatchingReservationWithDuration(bookingTime, reservation)
            );
          });
        });
      });
    }
  };
  useEffect(() => {
    setIsTableError(isTimeMatchingReservation() || false);
  }, [bookingTime, date, floorData]);
  const getMaxCapacitySum = () => {
    let totalCapacity = 0;
    for (const table of tableData?.AssetAllocation) {
      totalCapacity += table.Capacity.Max;
    }
    return totalCapacity;
  };
  const getMinCapacitySum = () => {
    let totalCapacity = 0;
    for (const table of tableData?.AssetAllocation) {
      totalCapacity += table.Capacity.Min;
    }
    return totalCapacity;
  };
  useEffect(() => {
    if (tableData?.AssetAllocation.length === 0) {
      setIsAlertVisible("danger");
    } else if (
      getMinCapacitySum() > guest &&
      tableData?.AssetAllocation.length === 1
    ) {
      setIsAlertVisible("warning-3");
    } else if (
      (getMaxCapacitySum() / 2 > guest || getMaxCapacitySum() < guest) &&
      tableData?.AssetAllocation.length > 0
    ) {
      setIsAlertVisible("warning-2");
    } else {
      setIsAlertVisible("");
    }
  }, [guest, tableData?.AssetAllocation]);
  useEffect(() => {
    if (statusValue) {
      if (statusValue.DisplayName === "Wait List") {
        setWaitCheck(true);
      } else {
        setWaitCheck(false);
      }
    }
  }, [statusValue]);
  const dispatch = useDispatch();

  const [tab, setTab] = useState<string>("DETAILS");
  if (!isModalOpen) {
    return null;
  }
  const getAlert = () => {
    if (isAlertVisible === "danger") {
      return <Alert type='danger' content='You need to select a table.' />;
    } else if (isAlertVisible === "warning") {
      return <Alert type='warning' content={`Tables are over-utilized.`} />;
    } else if (isAlertVisible === "warning-2") {
      return (
        <Alert
          type='warning'
          content={`Tables are over-utilized. Maximum capacity is ${getMaxCapacitySum()}`}
        />
      );
    } else if (isAlertVisible === "warning-3") {
      return (
        <Alert
          type='warning'
          content={`Tables are under-utilized. Minimum  capacity is ${getMinCapacitySum()}`}
        />
      );
    }
  };
  const getError = () => {
    return (
      <Alert
        type='danger'
        content={`The selected table is not available for the chosen booking time ${bookingTime}. Please select a different table or time slot`}
      />
    );
  };
  const detail = [
    {
      head: "Date",
      sub: moment(date).format("ddd,MMMM DD"),
      icon: calendar,
      isOpen: isDatOpen,
      hide: false,
    },
    {
      head: "Time",
      sub: (
        <TimeInput
          value={bookingTime}
          setValue={setBookingTime}
          setTimeOpen={() => {
            setStatusOpen(false);
            setDateOpen(false);
            setTimeOpen(!isTimeOpen);
            setTagOpen(false);
            setCoversOpen(false);
            setDurationOpen(false);
            setRequestOpen(false);
          }}
          newReservation
          date={date}
        />
      ),
      icon: est,
      isOpen: isTimeOpen,
      hide: false,
    },
    {
      head: "Party Size",
      sub: (
        <NumberInput
          value={guest}
          setValue={setGuest}
          setCoversOpen={() => {
            setStatusOpen(false);
            setDateOpen(false);
            setTimeOpen(false);
            setTagOpen(false);
            setCoversOpen(!isCoversOpen);
            setDurationOpen(false);
            setRequestOpen(false);
          }}
          newReservation
        />
      ),
      icon: covers,
      isOpen: isCoversOpen,
      hide: false,
    },
    {
      head: "Duration",
      sub: (
        <DurationInput
          value={time}
          setValue={setTime}
          interval={interval}
          setDurationOpen={() => {
            setStatusOpen(false);
            setDateOpen(false);
            setTimeOpen(false);
            setTagOpen(false);
            setCoversOpen(false);
            setDurationOpen(!isDurationOpen);
            setRequestOpen(false);
          }}
          newReservation
        />
      ),
      icon: duration,
      isOpen: isDurationOpen,
      hide: false,
    },
    {
      head: "Table",
      sub: (
        <div style={{ columnGap: "0.5rem", display: "flex" }}>
          {tableData?.AssetAllocation?.map((table: any) => {
            return <div>{table.Name}</div>;
          })}
        </div>
      ),
      icon: table,
      hide: false,
    },
    {
      head: "Status",
      sub: (
        <div
          style={{
            color: statusValue?.Color,
            display: "flex",
            alignItems: "center",
            columnGap: "5px",
          }}
        >
          <img
            alt=''
            src={statusValue?.Icon ? statusValue?.Icon : statusValue?.Image}
            style={{ height: "14px" }}
          />
          <img />
          {statusValue?.DisplayName}
        </div>
      ),
      icon: status,
      isOpen: isStatusOpen,
      hide: false,
    },
    {
      head: "Wait Est.",
      sub: waitESt,
      icon: est,
      isOpen: isWaitOpen,
      hide: !waitCheck,
    },
    {
      head: "Reserve ID",
      sub: `# ${tableData.ConfirmationNumber}`,
      icon: reserve,
      hide: false,
    },
  ];
  const data = [
    // {
    //   head: "Guest Tags",
    //   sub: "Select tags",
    //   icon: tag,
    // },
    // {
    //   head: "Tags",
    //   sub: <div>{tags.map((tag) => tag.Name)}</div>,
    //   icon: notes,
    //   hide: false,
    //   isOpen: isTagOpen,
    // },
    {
      head: "Notes",
      sub: isRequestOpen ? request : request === "" ? "None" : request,
      icon: tag,
      hide: false,
      isOpen: isRequestOpen,
    },
    // {
    //   head: "Private Comments",
    //   sub: "Write comments only your team can see",
    //   icon: comment,
    // },
    // {
    //   head: "Guest Notes",
    //   sub: "Add internal guest notes here",
    //   icon: notes,
    // },
    // {
    //   head: "Employee",
    //   sub: "Select reservation taker",
    //   icon: man,
    // },
    // {
    //   head: "Fields:",
    //   sub: "Add additional details",
    //   icon: note,
    // },
  ];
  const profileDetails = [
    {
      head: "First Name",
      sub: tableData.CustomerDetails.FirstName,
    },
    {
      head: "Last Name",
      sub: tableData.CustomerDetails.LastName,
    },
    {
      head: "Gender",
      sub: "---",
    },
    {
      head: "Date of Birth",
      sub: "---",
    },
    {
      head: "Anniversary",
      sub: "---",
    },
    {
      head: "Title",
      sub: "---",
    },
    {
      head: "Phone",
      sub: `${tableData.CustomerDetails.ContactDetails[0].PhoneCode} ${tableData.CustomerDetails.ContactDetails[0].Number}`,
    },
    {
      head: "Email",
      sub: tableData.CustomerDetails.Email,
    },
    {
      head: "Job Title",
      sub: "---",
    },
    {
      head: "Company",
      sub: "---",
    },
  ];
  const profileData = [
    {
      head: "Total Spend",
      sub: 0,
    },
    {
      head: "Spend Per Cover",
      sub: 0,
    },
    {
      head: "Upcoming Reservations",
      sub: 1,
    },
    {
      head: "Materialised Reservations",
      sub: 0,
    },
    {
      head: "Denied",
      sub: 0,
    },
    {
      head: "No Show",
      sub: 0,
    },
    {
      head: "Cancelled",
      sub: 0,
    },
    {
      head: "Review",
      sub: 0,
    },
  ];
  const handleItemOnClick = (item: string) => {
    switch (item) {
      case "Status":
        setDateOpen(false);
        setTimeOpen(false);
        setTagOpen(false);
        setCoversOpen(false);
        setDurationOpen(false);
        setRequestOpen(false);
        setStatusOpen(!isStatusOpen);
        break;
      case "Date":
        setTimeOpen(false);
        setTagOpen(false);
        setCoversOpen(false);
        setDurationOpen(false);
        setRequestOpen(false);
        setStatusOpen(false);
        setDateOpen(!isDatOpen);
        break;
      case "Time":
        setTagOpen(false);
        setCoversOpen(false);
        setDurationOpen(false);
        setRequestOpen(false);
        setStatusOpen(false);
        setDateOpen(false);
        setTimeOpen(!isTimeOpen);
        break;
      case "Tags":
        setCoversOpen(false);
        setDurationOpen(false);
        setRequestOpen(false);
        setStatusOpen(false);
        setDateOpen(false);
        setTimeOpen(false);
        setTagOpen(!isTagOpen);
        break;
      case "Notes":
        setStatusOpen(false);
        setDateOpen(false);
        setTimeOpen(false);
        setTagOpen(false);
        setCoversOpen(false);
        setDurationOpen(false);
        setRequestOpen(!isRequestOpen);
        break;
      case "Wait Est.":
        setCoversOpen(false);
        setDurationOpen(false);
        setRequestOpen(false);
        setStatusOpen(false);
        setDateOpen(false);
        setTimeOpen(false);
        setTagOpen(false);
        setWaitOpen(!isWaitOpen);
        break;
      default:
        break;
    }
  };
  const filteredDetail = detail.filter((item) => {
    return !item.hide;
  });
  const getLeftContent = () => {
    if (tab === "DETAILS") {
      return (
        <div className='inner-container'>
          {filteredDetail.map((item) => {
            return (
              <>
                {item.head === "Table" && isTableError && (
                  <div className='alert'>{getError()}</div>
                )}
                {item.head === "Table" && isAlertVisible !== "" && (
                  <div className='alert'>{getAlert()}</div>
                )}

                <div
                  className={`${
                    item.head === "Time" ||
                    item.head === "Party Size" ||
                    item.head === "Duration"
                      ? "item-def "
                      : "item"
                  } ${item.isOpen ? "item-sel" : ""}`}
                  onClick={() => {
                    if (item.head === "Table") {
                      dispatch(setAllocatedTables(tableData?.AssetAllocation));
                      setSelectedTables(true);
                      setIsModalOpen(false);
                    }
                    if (
                      item.head === "Date" ||
                      item.head === "Status" ||
                      item.head === "Wait Est."
                    ) {
                      handleItemOnClick(item.head);
                    }
                  }}
                >
                  <div className='det'>
                    <div className='head'>
                      <img alt='' src={item.icon} />
                      {item.head}
                    </div>
                    <div className='sub'>{item.sub}</div>
                  </div>
                  {item.head !== "Party Size" &&
                    item.head !== "Duration" &&
                    item.head !== "Time" &&
                    item.head !== "Reserve ID" && (
                      <div className='arrow-cont'>
                        <img alt='' src={back} />
                      </div>
                    )}
                </div>
              </>
            );
          })}
        </div>
      );
    } else {
      return (
        <div className='inner-container'>
          {profileDetails.map((item) => {
            return (
              <div className='item'>
                <div className='det'>
                  <div className='head'>{item.head}</div>
                  <div className='sub-gr'>{item.sub}</div>
                </div>
              </div>
            );
          })}
        </div>
      );
    }
  };

  const getRightContent = () => {
    if (tab === "DETAILS") {
      return (
        <div className='inner-container'>
          {data.map((item) => {
            return (
              <div>
                <div
                  className='item'
                  onClick={() => handleItemOnClick(item.head)}
                >
                  <div className='det'>
                    <div className='head'>
                      <img alt='' src={item.icon} />
                      {item.head}
                    </div>
                    <div className='sub'> {item.sub}</div>
                  </div>
                  <div className='arrow-cont'>
                    <img alt='' src={back} />
                  </div>
                </div>
                {isRequestOpen && (
                  <div className='content'>
                    <TextArea
                      label='Add Note'
                      value={request}
                      onChange={(value) => {
                        setRequest(value);
                      }}
                    />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      );
    } else {
      return (
        <div className='inner-container'>
          {profileData.map((item) => {
            return (
              <div className='item'>
                <div className='det'>
                  <div className='head'>{item.head}</div>
                  <div className='sub'>{item.sub}</div>
                </div>
              </div>
            );
          })}
        </div>
      );
    }
  };
  const handleSave = (from: string) => {
    if (
      !isTableError &&
      tableData?.AssetAllocation.length > 0 &&
      (isAlertVisible === "" ||
        (isAlertVisible !== "danger" && isAlertVisible !== "warning-3")) &&
      getMaxCapacitySum() >= guest
    ) {
      handleUpdate(from);
    }
    if (
      !isTableError &&
      tableData?.AssetAllocation.length > 0 &&
      isAlertVisible === "warning-2"
    ) {
      setIsUpdateOpen(true);
    }
  };
  const handleUpdate = (from: string) => {
    let bookingDetails = {
      ...tableData.BookingDetails,
      BookingDate: moment(date).format("YYYY-MM-DDTHH:mm:ss[Z]"),
      BookingTime: bookingTime,
      Duration: convertTimeToMinutes(time),
      NumberOfPeople: guest,
    };
    let newTableDate = {
      ...tableData,
      Status: statusValue?.DisplayName,
      StatusInfo: statusValue,
      BookingDetails: bookingDetails,
      ReservationNotes: request,
      WaitList: {
        Enabled: waitCheck,
        WaitTime: waitCheck ? convertTimeToMinutes(waitESt) : 0,
      },
    };
    if (from === "save") {
      setIsSaveLoading(true);
    } else {
      setIsLoading(true);
    }

    updateReservation(newTableDate).then(() => {
      dispatch(setAllocatedTables([]));
      if (from === "save") {
        setIsSaveLoading(false);
        setIsSaveOpen(false);
        setIsModalOpen(false);
      } else {
        setIsLoading(false);
        setIsModalOpen(false);
      }
      setIsUpdateSuccess(true);
    });
  };
  const areAssetsEqual = (arr1: any, arr2: any) => {
    if (arr1.length !== arr2.length) {
      return false;
    }

    const sortedArr1 = arr1.slice().sort();
    const sortedArr2 = arr2.slice().sort();

    return sortedArr1.every(
      (value: any, index: number) => value === sortedArr2[index]
    );
  };
  const checkIsSame = () => {
    let isSame = true;
    if (
      selectedRes?.BookingDetails?.BookingDate !==
      moment(date).format("YYYY-MM-DDTHH:mm:ss[Z]")
    ) {
      isSame = false;
    }
    if (selectedRes?.BookingDetails.BookingTime !== bookingTime) {
      isSame = false;
    }
    if (selectedRes?.BookingDetails.NumberOfPeople !== guest) {
      isSame = false;
    }
    if (selectedRes?.BookingDetails.Duration !== convertTimeToMinutes(time)) {
      isSame = false;
    }
    if (
      statusValue?.DisplayName === "Wait List" &&
      selectedRes.WaitList.WaitTime !== convertTimeToMinutes(waitESt)
    ) {
      isSame = false;
    }
    if (selectedRes?.Status !== statusValue?.DisplayName) {
      isSame = false;
    }
    if (selectedRes?.ReservationNotes?.trim() !== request?.trim()) {
      isSame = false;
    }
    if (
      !areAssetsEqual(
        selectedRes?.AssetAllocation.map((table: any) => table.RefNo),
        tableData?.AssetAllocation.map((table: any) => table.RefNo)
      )
    ) {
      isSame = false;
    }
    return isSame;
  };
  return (
    <div
      className='FloorDetails-overlay'
      onClick={() => {
        dispatch(setAllocatedTables([]));
        onClose();
      }}
    >
      <div
        className='FloorDetails-content'
        onClick={(e) => e.stopPropagation()}
      >
        <div className='header-container-new'>
          <div className='header'>
            <img
              alt=''
              src={back}
              onClick={() => {
                if (checkIsSame()) {
                  setIsModalOpen(false);
                } else {
                  setIsSaveOpen(true);
                }
              }}
            />
            Reservation Details
          </div>
          <div className='button-container'>
            <Button
              auth
              text='Save'
              height='40px'
              padding='0.75rem 2rem'
              onClick={() => {
                if (!(selectedRes && checkIsSame())) {
                  handleSave("table");
                }
              }}
              loading={isLoading}
              disable={selectedRes && checkIsSame()}
            />
          </div>
        </div>
        <div className='profile-details'>
          <div className='profile'>
            <div className='avatar'>
              {tableData.CustomerDetails.FirstName.charAt(0)}
              {/* <div className='edit'>
                <img alt='' src={edit} />
              </div> */}
            </div>
            <div className='name-conatiner'>
              <div className='name'>
                {" "}
                {tableData.CustomerDetails.FirstName}{" "}
                {tableData.CustomerDetails.LastName}
              </div>
              {tableData.CustomerDetails.Email &&
                tableData.CustomerDetails.Email !== "" && (
                  <div className='email'>
                    <img alt='' src={email} />
                    <td> {tableData.CustomerDetails.Email}</td>
                  </div>
                )}
            </div>
          </div>
          <div className='more'>
            <img alt='' src={more} />
          </div>
        </div>
        <div className='tab-bar'>
          <div
            className={`item ${tab === "DETAILS" ? "selected" : ""} `}
            onClick={() => setTab("DETAILS")}
          >
            Details
          </div>
          <div
            className={`item ${tab === "PROFILE" ? "selected" : ""} `}
            onClick={() => setTab("PROFILE")}
          >
            Profile
          </div>
        </div>
        <div className='container'>
          <div className='left-container'>{getLeftContent()}</div>
          <div className='right-container'>{getRightContent()}</div>
        </div>
      </div>
      {isDatOpen && (
        <DateModal
          date={date}
          setDate={setDate}
          setDateOpen={setDateOpen}
          isOpen={isDatOpen}
          onClose={() => {
            setDateOpen(false);
          }}
          isEdit={true}
        />
      )}
      {isStatusOpen && (
        <StatusModal
          isOpen={isStatusOpen}
          onClose={() => {
            setStatusOpen(false);
          }}
          setStatus={setStatusValue}
          isEdit={true}
        />
      )}
      {isDurationOpen && (
        <DurationModal
          isOpen={isDurationOpen}
          onClose={() => {
            setDurationOpen(false);
          }}
          interval={interval}
          setInterval={setInterval}
          isEdit={true}
        />
      )}
      {isCoversOpen && (
        <CoverModal
          isOpen={isCoversOpen}
          onClose={() => {
            setCoversOpen(false);
          }}
          cover={guest}
          setCover={setGuest}
          isEdit={true}
        />
      )}
      {isTimeOpen && (
        <TimeModal
          time={bookingTime}
          setTime={setBookingTime}
          isOpen={isTimeOpen}
          onClose={() => {
            setTimeOpen(false);
          }}
          isEdit={true}
          date={date}
        />
      )}
      {isWaitOpen && (
        <EstModal
          isOpen={isWaitOpen}
          onClose={() => {
            setWaitOpen(false);
          }}
          waitEst={waitESt}
          setWaitEst={setWaitsEst}
          isEdit={true}
        />
      )}
      {/* {isRequestOpen && (
        <NotesModal
          notes={request}
          setNotes={setRequest}
          isOpen={true}
          onClose={() => {
            setRequestOpen(false);
          }}
          isEdit={true}
        />
      )}
      {isTagOpen && (
        <TagModal
          isOpen={isTagOpen}
          onClose={() => {
            setTagOpen(false);
          }}
          setTags={setTagsData}
          tags={tags}
          isEdit={true}
        />
      )} */}

      <WarningModal
        isOpen={isSaveOpen}
        onClose={() => {
          dispatch(setAllocatedTables([]));
          onClose();
        }}
        onOk={() => {
          if (!isSaveLoading) {
            handleSave("save");
          }
        }}
        content='You have unsaved changes. Do you want to continue?'
        isLoading={isSaveLoading}
        header='Warning'
        secondary={true}
        primaryText='Save'
      />
      <WarningModal
        isOpen={isUpdateOpen}
        onClose={() => {
          dispatch(setAllocatedTables([]));
          onClose();
        }}
        onOk={() => {
          if (!isSaveLoading) {
            handleUpdate("save");
          }
        }}
        content='Selected table(s) are over-utilized. Do you want to save your changes?'
        isLoading={isSaveLoading}
        header='Warning'
        secondary={true}
        primaryText='Save'
      />
    </div>
  );
};

export default FloorDetails;
